import React from "react";
import { Link } from "react-router-dom";

const NotLoggedIn = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center">
        <h1 className="text-2xl font-bold text-gray-800 mb-4">Access Denied</h1>
        <p className="text-gray-600 mb-6">
          You are not logged in. Please log in to access this page.
        </p>
        <Link to="/login">
          <button className="bg-blue-600 text-white px-5 py-2 rounded-4xl hover:bg-blue-800 active:bg-white active:text-blue-800">
            Go to Login
          </button>
        </Link>
      </div>
    </div>
  );
};

export default NotLoggedIn;
